<!-- 患者查询 -->

<template>
  <div class="labelAuditList">
    <!-- <div class="search">
      <Input
        v-model="labelName"
        class="searchInput"
        search
        enter-button="查询"
        placeholder="请输入标签名称"
        @on-search="search"
      />
    </div> -->
    <Table :columns="columns1" :data="tableData" :height="u_table_heigh">
      <template slot-scope="{ row, index }" slot="active">
        <Button type="text" size="small" @click="setStatus(row)">{{
          row.approve ? "取消认同" : "认同"
        }}</Button>
      </template>
    </Table>
    <Page
      size="small"
      v-if="tableData.length > 0"
      show-total
      @on-change="getPatientHistoryList"
      :total="totalCount"
      :page-size="pageSize"
      @on-page-size-change="setPageSize"
      :current="pageIndex"
    ></Page>
    <!-- show-sizer -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import request from "@/utils/request";
export default {
  props: {
    baihuiLabelType: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      labelName: "",
      totalCount: 0,
      tableData: [],
      u_table_heigh: 300,
      pageIndex: 1,
      pageSize: 10, //一页10条
      columns1: [
        {
          title: "申请添加标签名称",
          key: "labelName",
          minWidth: 140,
        },
        {
          title: "标签分类",
          key: "labelTypeStr",
          width: 120,
        },
        {
          title: "认同人数",
          key: "approveNum",
          width: 120,
          align: "center",
        },
        {
          title: "操作",
          slot: "active",
          width: 120,
          align: "center",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["dicts"]),
  },
  methods: {
    setStatus(item) {
      let obj = {
        approveStatus: item.approve ? 0 : 1, //	1认可 0 取消认可		false
        labelId: item.labelId,
      };
      request.post("/saasbaihui/approveLabel", obj).then((res) => {
        this.$Message.success(res.result);
        item.approve = obj.approveStatus;
        if (obj.approveStatus) {
          item.approveNum += 1;
        } else {
          item.approveNum -= 1;
        }
      });
    },
    setPageSize(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.getData();
    },
    getPatientHistoryList(page) {
      this.pageIndex = page;
      this.getData();
    },
    getData() {
      let obj = {
        pageIndex: this.pageIndex, //当前页
        pageSize: this.pageSize, //每页条数
        labelStatus: 0,
        labelName: this.labelName,
      };
      this.tableData = [];
      request.post("/saasbaihui/labelAuditList", obj).then((res) => {
        res.result.forEach((item) => {
          item.labelTypeStr = this.common.valueToLabel(
            this.baihuiLabelType,
            item.labelType
          );
        });
        this.tableData = res.result;
        this.totalCount = res.total;
      });
    },
    search() {
      this.pageIndex = 1;
      this.getData();
    },
    init() {
      this.getData();
    },
  },
  created() {
    this.init();
  },
  mounted: function () {},
};
</script>
<style lang="scss">
.labelAuditList {
  .ivu-table {
  }
  .ivu-page {
    padding-top: 10px;
  }
  .search {
    margin-bottom: 10px;
    align-items: center;
    .ivu-input {
      width: 100% !important;
    }
    .searchInput {
      width: 100% !important;
      .ivu-input-search {
        background: #853a2f !important;
      }
    }
  }
}
</style>
